var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackwards15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "37px",
    viewBox: "0 0 33 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5F863927-D8BF-4102-B3B2-F2E8B99885C0@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schools/Web-Player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schools/Lessons/Player",
    transform: "translate(-522.000000, -694.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(508.000000, 684.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Default/15-Back"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08)-Icon/1)-Default/Rewind",
    transform: "translate(30.000000, 30.000000) rotate(21.000000) translate(-30.000000, -30.000000) translate(7.000000, 7.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Rewind"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.017149,39 C31.8536998,39.0094581 39.0094617,31.8536933 39,23.0171425 C38.9905195,14.1805917 31.8194019,7.00947691 22.982851,7 C14.1463002,6.99054185 6.99053828,14.1463067 7,22.9828575",
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    transform: "translate(23.000000, 23.000000) scale(-1, 1) rotate(-140.000000) translate(-23.000000, -23.000000) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.167066, 11.025895)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08)-Icon/1)-Default/Play",
    transform: "translate(4.000000, 4.000000) scale(-1, 1) rotate(22.000000) translate(-4.000000, -4.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42600975,1.63901463 L7.469329,6.2039935 C7.62618146,6.43927219 7.56260444,6.75715729 7.32732575,6.91400975 C7.24322078,6.97007973 7.14440084,7 7.04331925,7 L0.956680751,7 C0.673910959,7 0.444680751,6.77076979 0.444680751,6.488 C0.444680751,6.38691841 0.474601021,6.28809847 0.530671,6.2039935 L3.57399025,1.63901463 C3.73084271,1.40373594 4.04872781,1.34015892 4.2840065,1.49701138 C4.34025087,1.53450762 4.3885135,1.58277025 4.42600975,1.63901463 Z",
    id: "Icon-color",
    transform: "translate(4.000000, 4.000000) rotate(-270.000000) translate(-4.000000, -4.000000) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(16.458331, 12.524322)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "08)-Icon/1)-Default/Play",
    transform: "translate(4.000000, 4.000000) scale(-1, 1) rotate(22.000000) translate(-4.000000, -4.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42600975,1.63901463 L7.469329,6.2039935 C7.62618146,6.43927219 7.56260444,6.75715729 7.32732575,6.91400975 C7.24322078,6.97007973 7.14440084,7 7.04331925,7 L0.956680751,7 C0.673910959,7 0.444680751,6.77076979 0.444680751,6.488 C0.444680751,6.38691841 0.474601021,6.28809847 0.530671,6.2039935 L3.57399025,1.63901463 C3.73084271,1.40373594 4.04872781,1.34015892 4.2840065,1.49701138 C4.34025087,1.53450762 4.3885135,1.58277025 4.42600975,1.63901463 Z",
    id: "Icon-color",
    transform: "translate(4.000000, 4.000000) rotate(-270.000000) translate(-4.000000, -4.000000) "
  })))), /*#__PURE__*/React.createElement("text", {
    id: 15,
    fontFamily: "Lato-Regular, Lato",
    fontSize: 13,
    fontWeight: "normal",
    "line-spacing": 16,
    letterSpacing: 0.108333333,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 22.3516667,
    y: 34.0833333
  }, "15")))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwards15X);
export default __webpack_public_path__ + "static/media/Backwards@1.5x.c3212af5e8d9d34075915ac2e1ed2a39.svg";
export { ForwardRef as ReactComponent };